import { GroupAddOutlined } from '@mui/icons-material';
import { Tabs } from 'finara-components';
import type { TabItem } from 'finara-components';
import { useState } from 'react';

import { Navbar } from '@/components/admin/general/Navbar';
import { adminNavItems } from '@/data/admin/general/navigationData';
import { useAuth } from '@/hooks/useAuth';

import { DashboardTab } from './components/DashboardTab';
import { OnboardingListTab } from './components/OnboardingListTab';
import { ProcessFlowTab } from './components/ProcessFlowTab';

export const OnboardingPage: React.FC = () => {
  const { user } = useAuth();
  const [activeTab, setActiveTab] = useState('dashboard');

  const tabs: TabItem[] = [
    { id: 'dashboard', title: 'Dashboard', onSelect: () => setActiveTab('dashboard') },
    { id: 'lista', title: 'Lista de Onboardings', onSelect: () => setActiveTab('lista') },
    { id: 'flujo', title: 'Flujo del Proceso', onSelect: () => setActiveTab('flujo') },
  ];

  const renderTabContent = () => {
    switch (activeTab) {
      case 'dashboard':
        return <DashboardTab />;
      case 'lista':
        return <OnboardingListTab />;
      case 'flujo':
        return <ProcessFlowTab />;
      default:
        return <DashboardTab />;
    }
  };

  return (
    <div className="min-h-screen">
      <Navbar
        navItems={adminNavItems}
        userName={user?.name || 'Usuario'}
        pageTitle="Onboarding de Empleados"
        section="Empleados"
      />

      <div className="px-4 py-8">
        {/* Header */}
        <div className="mb-6">
          <div className="lg:flex items-center justify-between">
            <div className="mb-4 lg:!mb-0">
              <h1 className="text-2xl font-bold text-brand-white flex items-center gap-2">
                <GroupAddOutlined />
                Onboarding de Empleados
              </h1>
              <p className="text-muted mt-1">
                Gestión completa del proceso de incorporación de nuevos empleados
              </p>
            </div>
          </div>
        </div>

        {/* Tabs */}
        <div className="mb-6">
          <Tabs tabs={tabs} activeTabId={activeTab} />
        </div>

        {/* Tab Content */}
        {renderTabContent()}
      </div>
    </div>
  );
};
